/**
 * Global imports
 */
import svg4everybody from 'svg4everybody';
import MobileMenu from './components/mobile-menu';
import headerFilter from './components/headerFilter';
import archiveDialog from './blocks/archiveDialog';
import wheel from './components/wheel';
import recommendations from './components/recommendations';

document.addEventListener('DOMContentLoaded', () => {
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }
    window.onload = function () {
        window.scrollTo(0, 0);
    };

    svg4everybody();
    MobileMenu();
    headerFilter();
    archiveDialog();
    wheel();
    recommendations();
});
